var React = require('react');

function TimelineTrailThree (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 1C11.3333 29.8333 38.3 85.8 91.5 79C158 70.5 242.5 97 211.5 172.5C180.5 248 198 283.5 303 304","stroke":"#484B53","strokeOpacity":"0.18","strokeWidth":"8","strokeDasharray":"16 16"}));
}

TimelineTrailThree.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 304 308","fill":"none"};

module.exports = TimelineTrailThree;

TimelineTrailThree.default = TimelineTrailThree;
